<div class="info-content-container">
    <div class="title-header">
        <span>{{ headline }}</span>
        @if (historyStack?.length) {
            <button type="button" class="icon-button faq-back" (click)="goBackInList()">
                <span class="icon-chevron-left"></span>
            </button>
        }
    </div>
    <div class="scroll-container">
        @if (filteredChildren?.length || (!historyStack?.length && filteredChildren?.length)) {
            <div class="master-faq-list-container">
                <div class="master-faq-content">
                    <div class="faq-layer">
                        <div class="slider">
                            <div class="faq-topic-layer">
                                <ul>
                                    @for (item of filteredChildren; track item) {
                                        <li (click)="selectItem(item)">
                                            <a>{{ getItemTitle(item.title) }}</a>
                                            @if (!item.endNode) {
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.status.draft' | translate }}</label>
                                                    <span>{{ item.draftItems || 0 }}</span>
                                                </div>
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.status.inProgress' | translate }}</label>
                                                    <span>{{ item.inProgressItems || 0 }}</span>
                                                </div>
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.status.released' | translate }}</label>
                                                    <span>{{ item.releasedItems || 0 }}</span>
                                                </div>
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.item.childrenNodes' | translate }}</label>
                                                    <span>{{ item.totalItems || 0 }}</span>
                                                </div>
                                            } @else {
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.item.language' | translate }}</label>
                                                    <span>{{
                                                        'generic.languages.' + (item.selectedLanguage || 'none')
                                                            | translate
                                                    }}</span>
                                                </div>
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.item.doc' | translate }}</label>
                                                    <span>{{ item.doc | percent }}</span>
                                                </div>
                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.item.reportStatus' | translate }}</label>
                                                    <span>{{ 'report.status.' + item.reportStatus | translate }}</span>
                                                </div>

                                                <div class="faq-info-cell">
                                                    <label>{{ 'report.item.lastModified' | translate }}</label>
                                                    <span>{{ item.modifiedAt | date }}</span>
                                                </div>
                                                <div class="button-container-cell">
                                                    <button
                                                        (click)="$event.stopPropagation()"
                                                        matTooltip="{{ 'report.item.goToReport' | translate }}"
                                                        [routerLink]="['/report', item.id]"
                                                        class="icon-button"
                                                    >
                                                        <span class="icon-view"></span>
                                                    </button>
                                                    <button
                                                        matTooltip="{{ 'report.item.editReport' | translate }}"
                                                        [disabled]="isFinished(item)"
                                                        (click)="$event.stopPropagation(); editReport(item)"
                                                        class="icon-button"
                                                    >
                                                        <span class="icon-edit"></span>
                                                    </button>
                                                    <button
                                                        matTooltip="{{ 'report.item.exportReport' | translate }}"
                                                        (click)="$event.stopPropagation(); exportItem(item)"
                                                        class="icon-button"
                                                    >
                                                        <span class="icon-download"></span>
                                                    </button>
                                                    <button
                                                        matTooltip="{{ 'report.item.resetReportButton' | translate }}"
                                                        [disabled]="isFinished(item)"
                                                        (click)="$event.stopPropagation(); resetReport(item)"
                                                        class="icon-button"
                                                    >
                                                        <span class="icon-reset"></span>
                                                    </button>
                                                    <button
                                                        matTooltip="{{ 'report.item.deleteReport' | translate }}"
                                                        [disabled]="isFinished(item)"
                                                        (click)="$event.stopPropagation(); deleteReport(item)"
                                                        class="icon-button"
                                                    >
                                                        <span class="icon-delete"></span>
                                                    </button>
                                                </div>
                                            }
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="no-data-container">
                <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
                <span>{{ 'default.buttons.noData' | translate }}</span>
            </div>
        }
    </div>
</div>
